import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import style from "css/template.module.css";
import { useMediaQuery } from "react-responsive";
import { useTranslation } from "react-i18next";
import TermsModal from "component/common/termsModal";

/**
 * Version : 1.0
 * 작성일자 : 2025-02-10
 * 작성자 : 강연승
 * 설명 : footer
 */

function Footer(props) {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  //반응형
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1024px)",
  });
  // const check = useMediaQuery({ query: "(max-width: 1024px)" });

  const handleMenuClick = (type) => {
    props.handleNavLink(type);
  };

  //열려있는 약관 전문 종류 ("privacy" | "service" | null)
  const [termsType, setTermsType] = useState(null);

  if (pathname.startsWith("/signup")) return null;

  return (
    <>
      <div className={style.footer}>
        <div className={style.site_nav_wrap}>
          <img
            onClick={props.scrollToTop}
            src={
              `${process.env.REACT_APP_CLIENT_URL}` +
              (!isMobile && !isTablet
                ? `img/header/logo.png`
                : `img/header/logo.png`)
            }
            alt="logo"
          />
          <div className={style.site_nav_list}>
            <div
              className={style.site_nav_item}
              onClick={() => handleMenuClick("allplace")}
            >
              {t("footer.navAllplace")}
            </div>
            <div
              className={style.site_nav_item}
              onClick={() => handleMenuClick("feature")}
            >
              {t("footer.navFeature")}
            </div>
            <div
              className={style.site_nav_item}
              onClick={() => handleMenuClick("saas")}
            >
              {t("footer.navPricing")}
            </div>
          </div>
        </div>
        <div className={style.link_btn_wrap}>
          <div className={style.link_btn_list}>
            <div
              className={style.link_btn_item}
              onClick={() =>
                window.open(
                  "https://www.instagram.com/rivtechnology/",
                  "_blank",
                )
              }
            >
              <img
                src={`${process.env.REACT_APP_CLIENT_URL}img/footer/instagram.png`}
                alt="instagram"
              />
            </div>
            <div
              className={style.link_btn_item}
              onClick={() =>
                window.open("https://blog.naver.com/rivsw", "_blank")
              }
            >
              <img
                src={`${process.env.REACT_APP_CLIENT_URL}img/footer/blog.png`}
                alt="blog"
              />
            </div>
            <div
              className={style.link_btn_item}
              onClick={() =>
                window.open(
                  "https://www.facebook.com/profile.php?id=61563844645879",
                  "_blank",
                )
              }
            >
              <img
                src={`${process.env.REACT_APP_CLIENT_URL}img/footer/facebook.png`}
                alt="facebook"
              />
            </div>
          </div>
          <div
            className={style.homepage_link_btn}
            onClick={() => window.open("https://riv-tech.co.kr", "_blank")}
          >
            <span>{t("footer.rivWebsite")}</span>
            <img
              src={`${process.env.REACT_APP_CLIENT_URL}img/footer/link.png`}
              alt="link"
            />
          </div>
        </div>
        <div className={style.company_wrap}>
          <div className={style.company_info_area}>
            <div className={style.company_info}>
              <div>{t("footer.companyName")}</div>
              <div>{t("footer.businessNumber")}</div>
              <div>{t("footer.mailOrderNumber")}</div>
              <div>{t("footer.address")}</div>
              {!isMobile && !isTablet ? (
                <div>{t("footer.telEmail")}</div>
              ) : (
                <>
                  <div>{t("footer.telEmail")}</div>
                </>
              )}
            </div>
            {/* 이용약관·개인정보처리방침은 상시 공개 의무가 있어 푸터에 노출 */}
            <div className={style.company_policy}>
              <button
                type="button"
                className={style.company_policy_item}
                onClick={() => setTermsType("service")}
              >
                {t("footer.termsOfService")}
              </button>
              <button
                type="button"
                className={style.company_policy_item}
                onClick={() => setTermsType("privacy")}
              >
                {t("footer.privacyPolicy")}
              </button>
            </div>
          </div>
          <div className={style.copyright}>
            © 2026 Riv Technology. All rights reserved.
          </div>
        </div>
      </div>
      <TermsModal
        type={termsType}
        onClose={() => setTermsType(null)}
      />
    </>
  );
}

export default Footer;
